export function saveLocalStorageValue(key: string, value: string, legacyKey?: string) {
    localStorage.setItem(key, value);
    removeLegacyLocalStorageValue(key, legacyKey);
}

export function loadLocalStorageValue(key: string, legacyKey?: string): string | null {
    const value = localStorage.getItem(key);

    if (value !== null) {
        removeLegacyLocalStorageValue(key, legacyKey);

        return value;
    }

    if (!legacyKey) {
        return null;
    }

    const legacyValue = localStorage.getItem(legacyKey);

    if (legacyValue !== null) {
        localStorage.setItem(key, legacyValue);
        localStorage.removeItem(legacyKey);
    }

    return legacyValue;
}

function removeLegacyLocalStorageValue(key: string, legacyKey?: string) {
    if (legacyKey && legacyKey !== key) {
        localStorage.removeItem(legacyKey);
    }
}
